import { useSelector } from 'react-redux';
import { PANEL_MODES } from '../../editCourse/editCourseState';

const getGlobalUi = (state) =>
  state.globalUi || {
    menuSliderToggle: false,
    menuTocToggle: false,
    menuEditLeftToggle: false,
    menuEditLeftMode: PANEL_MODES.TOC,
    menuEditRightToggle: false,
    layoutOrganizerToggle: false,
    editRightPanelMode: 'module',
    notesSliderToggle: false,
    incarnateModal: false,
    loginModal: false,
  };

export const useLoginModal = () => useSelector((state) => getGlobalUi(state).loginModal);
export const useIncarnateModal = () => useSelector((state) => getGlobalUi(state).incarnateModal);
export const useMenuSliderToggle = () => useSelector((state) => getGlobalUi(state).menuSliderToggle);
export const useMenuTocToggle = () => useSelector((state) => getGlobalUi(state).menuTocToggle);
export const useMenuEditLeftToggle = () => useSelector((state) => getGlobalUi(state).menuEditLeftToggle);
export const useMenuEditLeftMode = () => useSelector((state) => getGlobalUi(state).menuEditLeftMode);
export const useMenuEditRightToggle = () => useSelector((state) => getGlobalUi(state).menuEditRightToggle);
export const useLayoutOrganizerToggle = () => useSelector((state) => getGlobalUi(state).layoutOrganizerToggle);
export const useEditRightPanelMode = () => useSelector((state) => getGlobalUi(state).editRightPanelMode);
export const useNotesSliderToggle = () => useSelector((state) => getGlobalUi(state).notesSliderToggle);
